export default () => ({
    loading: true,
    users : null,
    currentUser : null,
    errorMessage: null,
    totalItems: 0,
})